import React from 'react';

import Button from '@material-ui/core/Button';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import RefreshIcon from '@material-ui/icons/Refresh';

import { string } from 'prop-types';

import styles from './styles/index.scss';

function refreshPage() {
  location.reload();
}

const FailureScreen = ({ message }) => {
  return (
    <div className={styles.container}>
      <ErrorOutlineIcon className={styles.errorIcon} />
      <h2 className={styles.headline}>Oops! Something went wrong.</h2>
      <Button onClick={refreshPage} variant="contained" className={styles.btn}>
        <RefreshIcon className={styles.refreshIcon} />
        Retry
      </Button>
    </div>
  );
};

FailureScreen.propTypes = {
  message: string
};

export default FailureScreen;



// WEBPACK FOOTER //
// ./src/client/shared-components/FailureScreen/index.js